// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plan-btn[data-v-21525131]{width:-moz-fit-content;width:fit-content;border-radius:12px;padding:7px 24px;font-size:16px;font-weight:600}.plan-btn[data-v-21525131]:disabled{cursor:not-allowed;opacity:.6}.billing-footer-sticky[data-v-21525131]{position:fixed;left:225px;width:calc(100vw - 225px);bottom:0;z-index:10;height:90px;margin-left:0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
